module.exports = __webpack_public_path__ + "img/epr_medium@2x.ac7f1f79.jpg";